import React, { FC, ReactNode } from 'react'
import { AnimatePresence } from 'framer-motion'
import S from './Dialog.styles'

interface DialogProps {
  children: ReactNode
  /** rem unit value */
  maxWidth?: number | string
  /** show the thing */
  show?: boolean
  /** callback */
  onExit?: () => void
}

const Dialog: FC<DialogProps> = ({ children, maxWidth = '100%', show = false, onExit }) => {
  const exit = () => {
    onExit?.()
  }

  return (
    <AnimatePresence>
      {show && (
        <S.Wrapper>
          <S.Backdrop initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={exit} />
          <S.Dialog
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            $maxWidth={maxWidth}>
            {children}
          </S.Dialog>
        </S.Wrapper>
      )}
    </AnimatePresence>
  )
}

export default Dialog
